import React, { useEffect, useState, useRef, useReducer } from "react";
import DarkBarChart from "../graphComponents/BarChart.js";
import { fetchAdditionalGraphInfo } from "../data/graphData.js";

const AdditionalGraphs = () => {
  const [massPerYear, setMassPerYear] = useState({});
  const [, forceUpdate] = useReducer((x) => x + 1, 0); // Graph does not update on page resize; force update with this
  const chartRef = useRef(null); // Ref t access the chart container

  /*   useEffect(() => {
    (async () => {
      const [padData, zoneData, rocketData] = await Promise.all([
        fetchPads("", {}),
        fetchZones("", {}),
        fetchRockets(),
      ]);

      setPads(padData);
      setZones(zoneData);
      setRockets(rocketData);
      dataLoaded.current = true;
    })();
  }, []); */

  useEffect(() => {
    /*     if (!dataLoaded.current) {
      return;
    } */
    const fetchData = async () => {
      const [graphData] = await Promise.all([fetchAdditionalGraphInfo()]);

      setMassPerYear(graphData.mass_per_year);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      forceUpdate();
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="mx-auto graph-container">
      <div style={{ width: "100%" }}>
        <h2 className="centered-heading">Estimated Mass to Orbit</h2>
        <div className="chart-and-stats" ref={chartRef}>
          <DarkBarChart
            seriesInput={[
              {
                data: Object.values(massPerYear).map(Number),
                area: false,
                stack: "total",
                curve: "linear",
                color: "#238bb8",
                valueFormatter: (value, context) => `${value.toLocaleString()} tonnes`,
              },
            ]}
            xAxisInput={[{ data: Object.keys(massPerYear).map(Number), type: "linear", scaleType: "band" }]}
            showLegend={false}
            chartWidth={chartRef.current?.offsetWidth || 1000}
            totalLaunches={null}
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalGraphs;
